/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import NavLink from 'components/NavLink';
import treatHrefLink from 'utils/treatHrefLink';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const DiseaseList = ({ item }) => (
  <NavLink
    basePath={publicRuntimeConfig.PUBLIC_URL}
    as={`${item?.permalink}`}
    to={treatHrefLink(item)}
    routerStrategy={'next'}
  >
    {item.title}
  </NavLink>
);

DiseaseList.defaultProps = {
  item: {
    title: '',
    permalink: '',
  }
};

DiseaseList.propTypes = {
  item: PropTypes.object
};

export default DiseaseList;
